import { AppComponent } from 'src/app/app.component';
import { Component, OnInit } from '@angular/core';
import { LocalStorageService, MenuBreadCrumb, SessionService } from 'brainloper-ui';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-initial-page',
    templateUrl: './initial-page.component.html',
    styleUrls: ['./initial-page.component.scss'],
    standalone: false
})
export class InitialPageComponent implements OnInit {

  public minimalScreen : number = environment.minimalScreen
  public missingPaymentAlert : boolean = false
  public size: number = screen.width
  public isMobile : boolean = false;
  public menuBreadCrumb:Array<MenuBreadCrumb> = [{
    name:"Inicio",
    router:'/inicio',
    current:true
  }]
  public rolId: number | null = null

  constructor(
    private session: SessionService,
    private appCompnent: AppComponent,
    private storage : LocalStorageService
  ) {
    this.rolId = this.storage.get<number>('roleId')
  }
  async ngOnInit() {
    this.missingPaymentAlert = this.storage.get<boolean>('missingPaymentAlert')
    this.rolId = this.storage.get<number>('roleId')
    window.addEventListener('resize', () => {
      this.size = screen.width
      this.validateIfIsMobile()
    })
    if (this.session.getData('cargando') == true) {
      this.session.setData('cargando', false)
    }
    this.appCompnent.getNameCompany()
    this.validateIfIsMobile()
    this.appCompnent.getNotification()
  }

  private validateIfIsMobile(){
    if (
      navigator.userAgent.match(/Android/i) ||
      navigator.userAgent.match(/webOS/i) ||
      navigator.userAgent.match(/iPhone/i) ||
      navigator.userAgent.match(/iPad/i) ||
      navigator.userAgent.match(/iPod/i) ||
      navigator.userAgent.match(/BlackBerry/i) ||
      navigator.userAgent.match(/Windows Phone/i)
    ) {
      this.isMobile = true;
    }else{
      this.isMobile = false;
    }
  }



}
